import {
    getBaseData
} from '../../api/main'

export function baseHttp(res){
    if (!sessionStorage.getItem("cardTypeList")) {
        getBaseData({
            type: 'id_type_enum'
        }).then(res => {
            console.log(res.data)
            res.data.unshift({name:'全部',code:''})
            sessionStorage.setItem("cardTypeList", JSON.stringify(res.data))
        })
    }
    if (!sessionStorage.getItem("nationList")) {
        getBaseData({
            type: 'nation_enum'
        }).then(res => {
            res.data.unshift({name:'全部',code:''})
            sessionStorage.setItem("nationList", JSON.stringify(res.data))
        })
    }
    if (!sessionStorage.getItem("degreeList")) {
        getBaseData({
            type: 'degree_enum'
        }).then(res => {
            console.log(res.data)
            res.data.unshift({name:'全部',code:''})
            sessionStorage.setItem("degreeList", JSON.stringify(res.data))
        })
    }
    if (!sessionStorage.getItem("examSubjectList")) {
        getBaseData({
            type: 'exam_subject_enum'
        }).then(res => {
            res.data.unshift({name:'全部',code:''})
            console.log(res.data)
            sessionStorage.setItem("examSubjectList", JSON.stringify(res.data))
        })
    }
    if (!sessionStorage.getItem("technicalList")) {
        getBaseData({
            type: 'technical_position_enum'
        }).then(res => {
            res.data.unshift({name:'全部',code:''})
            console.log(res.data)
            sessionStorage.setItem("technicalList", JSON.stringify(res.data))
        })
    }
    if (!sessionStorage.getItem("educationList")) {
        getBaseData({
            type: 'education_enum'
        }).then(res => {
            res.data.unshift({name:'全部',code:''})
            console.log(res.data)
            sessionStorage.setItem("educationList", JSON.stringify(res.data))
        })
    }
}
